import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import DocumentUploader from 'ui-component/uploadDocument';
import toast from 'react-hot-toast';
import { get, post, put } from '../../axios/apiService';
import { useNavigate } from 'react-router';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import { isEmpty, validateAmount, validateMaxLength } from 'utils/validator';
import { useEffect } from 'react';
import { getFileNameFromUrl } from 'utils/urlToGetFileName';
import uploadFilesService from '../../axios/uploadFilesService';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Stack, styled } from '@mui/system';
import { generateUniqueId } from 'utils/commonfunction';
import NomineeDetails from 'ui-component/nomineeDetail';
import PhoneInput from 'react-phone-input-2';
import parsePhoneNumberFromString from 'libphonenumber-js';

const ResizableTextField = styled(TextField)({
  '& .MuiInputBase-inputMultiline': {
    resize: 'both',
    overflow: 'auto',
  },
});

function AddEditPolicyForm({ id, setIsShowForm, customerId }) {
  console.log('id', id);
  const [formErrors, setFormErrors] = useState({});
  const [isValidation, setIsValidation] = useState(false);
  const [isValidationNominee, setIsValidationNominee] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [usedPolicyNominees, setUsedPolicyNominees] = useState([]);
  const { control, handleSubmit, getValues, reset,watch } = useForm({
    defaultValues: {
      policyId: '',
      policyNumber: '',
      provider: '',
      expirationDate: '',
      coverAmount: 0,
      policyName: '',
      category: 0,
      policyDocuments: null
    }
  });

  const {
    control: nomineesControl,
    getValues: nomineesGetValues,
    reset: nomineesReset,
    watch: nomineesWatch,
  } = useForm({
    defaultValues: {
      address: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
  });

  const navigate = useNavigate();
  const [documentList, setDocumentList] = useState([]);
  const [existingDoc, setExistingDoc] = useState([]);

  const columns = [
    { field: "firstName", headerName: "First Name", flex: 1 },
    { field: "lastName", headerName: "Last Name", flex: 1 },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "allocationPercentage", headerName: "Allocation Percentage", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      renderCell: (params) => <ActionButtons {...params.row} />,
      // align: 'right',
      width: 200,
      sortable: false,
      filterable: false,
    },
  ];

  const watchedFields = [
    'policyNumber',
    'provider',
    'expirationDate',
    'coverAmount',
    'policyName',
    'category'
  ];

  const formValues = useMemo(() =>
    watchedFields.reduce((acc, field) => {
      acc[field] = watch(field);
      return acc;
    }, {}),
    watchedFields.map(watch)
  );

  useEffect(() => {
    if (isValidation) {
      validator(formValues);
    }
  }, [formValues, isValidation]);

  // useEffect(() => {
  //   if (isValidation) {
  //     validator(formValues);
  //   }
  // }, [formValues, isValidation]);

  useEffect(() => {
    if (isValidationNominee) {
      const formNomineesData = {
        firstName: nomineesWatch("firstName"),
        lastName: nomineesWatch("lastName"),
        address: nomineesWatch("address"),
        phone: nomineesWatch("phone"),
        allocationPercentage: nomineesWatch("allocationPercentage"),
      };
      validateNominees(formNomineesData);
    }
  }, [isValidationNominee, nomineesWatch("firstName"), nomineesWatch("lastName"), nomineesWatch("address"), nomineesWatch("phone"), nomineesWatch("allocationPercentage")]);

  useEffect(() => {
    if (id) {
      const getByIdLoan = async () => {
        setIsLoading(true);
        try {
          let response = await get(`Policy/getAllDetailByPolicyID/${id}`, null);
          if (response != null) {
            reset({
              policyId: response?.id || '',
              policyNumber: response?.policyNumber || '',
              provider: response.provider || '',
              expirationDate: formatDate(response.expirationDate) || '',
              coverAmount: response?.coverAmount,
              policyName: response?.policyName,
              category: Number(response.category) || 0,
              policyDocuments: response.policyDocuments
            });
            setExistingDoc(response.policyDocuments);
            setUsedPolicyNominees(response.policyNominees);
          }
        } catch (err) {
          console.error(err?.message);
        } finally {
          setIsLoading(false);
        }
      };
      getByIdLoan();
    }
  }, [id]);

  const handleUpload = (newFiles) => {
    setDocumentList((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemove = (index) => {
    setDocumentList((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };
  const handleRemoveExistDoc = (index) => {
    setExistingDoc((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };
  const onSubmit = async (data) => {
    setIsValidation(true);
    if (!validator()) return;
    setIsValidation(true);
    let uploadFileList = await uploadDocBlob();
    let policyDocuments =
      uploadFileList?.map((x) => ({
        blobUrl: x.fileName,
        fileName: documentList[x.fileId - 1].name
      })) || [];
    // if (!id && policyDocuments.length === 0) {
    //   toast.error('please upload document');
    //   return;
    // }

    if (!customerId) {
      toast.error('Please select customer');
      return;
    }

    if (usedPolicyNominees.length == 0) {
      toast.error("Please add at least one nominee");
      return;
    }
    let allocationTotal = 0;
    usedPolicyNominees.forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
    if (allocationTotal != 100) {
      toast.error("Allocation of all nominee(s) must be 100%");
      return;
    }

    const apiUrl = id ? `Policy/${id}` : 'Policy';
    let param = {
      policy: {
        policyNumber: data.policyNumber,
        provider: data.provider,
        expirationDate: data.expirationDate,
        category: data.category,
        customerId: customerId,
        policyName: data.policyName,
        coverAmount: data.coverAmount
        // currentRateOfInterest: parseInt(data.currentRateOfInterest)
      },
      policyDocuments: policyDocuments,
      policyNominees: usedPolicyNominees
    };
    if (id) {
      param.policy.id = id;
      let existingFileName = existingDoc?.map((x) => {
        let urlName = getFileNameFromUrl(x.blobUrl);
        return { ...x, blobUrl: urlName };
      });
      param.policyDocuments = [...policyDocuments, ...existingFileName];
      // if (param?.policyDocuments?.length === 0) {
      //   toast.error('please upload document');
      //   return;
      // }
    }
    

    try {
      setIsLoading(true);
      let response = id ? await put(apiUrl, param) : await post(apiUrl, param);
      if (response) {
        toast.success(id ? 'Policy updated successfully' : 'Policy added successfully');
      }
      // navigate('/will-management');
      setIsShowForm(false);
    } catch (error) {
      toast.error('Failed to save policy. Please try again.');
    } finally {
      setIsLoading(false);
      setIsValidation(false);
    }
  };

  const uploadDocBlob = async (data) => {
    const formData = new FormData();
    for (let i = 0; i < documentList.length; i++) {
      formData.append('files', documentList[i]);
      formData.append('fileIds', i + 1);
    }
    formData.append('categoryId', 3);
    try {
      let data = await uploadFilesService(formData);
      return data;
    } catch (error) {
      console.error('There was an error uploading the files!', error);
    }
  };

  const validator = () => {
    let data = getValues();
    const errors = {};
    if (data.category <= 0) {
      errors.category = 'Please Select Category';
    }
    if (isEmpty(data?.provider)) {
      errors.provider = 'Please Enter Provider';
    }
    if (isEmpty(data?.policyNumber)) {
      errors.policyNumber = 'Please Enter PolicyNumber';
    }

    if (isEmpty(data?.policyName)) {
      errors.policyName = 'Please Enter policyName';
    }

    if (!validateMaxLength(data?.policyNumber, 20)) {
      errors.policyNumber = ` The value exceeds the maximum allowed length of ${20} characters.`;
    }

    if (!validateAmount(data?.coverAmount, 1)) {
      errors.coverAmount = "Please enter a valid CoverAmount greater than or equal to 1.";
    }

    if (!data?.expirationDate) {
      errors.expirationDate = 'Please Enter Expiration Date';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveNominees = () => {
    let nomineesData = {
      firstName: nomineesGetValues("firstName"),
      lastName: nomineesGetValues("lastName"),
      address: nomineesGetValues("address"),
      phone: nomineesGetValues("phone"),
      id: generateUniqueId(),
      allocationPercentage: nomineesGetValues("allocationPercentage"),
    };
    setIsValidationNominee(true);
    if (!validateNominees(nomineesData)) return;
    setIsValidationNominee(false);
    try {
      setIsLoading(true);
      let newNominees = usedPolicyNominees;
      newNominees = [...newNominees, ...[nomineesData]];
      setUsedPolicyNominees(newNominees);
      nomineesReset({
        address: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        allocationPercentage: 0,
      });
    } catch (error) {
      console.error("An error occurred while saving nominees:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const validateNominees = (nomineesData) => {
    const errors = {};

    if (isEmpty(nomineesData?.firstName)) {
      errors.firstName = "Please Enter First Name";
    }

    if (isEmpty(nomineesData?.lastName)) {
      errors.lastName = "Please Enter Last Name";
    }
    let mobileNumber = nomineesData?.phone && nomineesData?.phone.startsWith('+') ? nomineesData?.phone : `+${nomineesData?.phone}`;
    let phoneNumber = parsePhoneNumberFromString(mobileNumber);

    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Invalid Phone Number";
    }

    if (isEmpty(nomineesData?.address)) {
      errors.address = "Please Enter Address";
    }

    // if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
    //   errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    // }
    // if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
    //   errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    // }

    // if(!isNaN(nomineesData?.allocationPercentage) && !addPercentage(nomineesData?.allocationPercentage,usedLoanNominees)){
    //   errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    // }

    if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    } else if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    } else {
      let allocationTotal = parseFloat(nomineesData?.allocationPercentage?.toString());
      usedPolicyNominees
        .filter((x) => x.id != nomineesData?.id)
        .forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
      if (allocationTotal > 100) {
        errors.allocationPercentage = "Allocation of all nominee(s) must be 100%";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const ActionButtons = (row) => {
    return (
      <Stack
        direction={"row"}
        spacing={1}
        justifyContent="center"
        sx={{ marginTop: "10px" }}
      >
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={() => {
            handleNomineeEdit(row.id);
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => {
            setUsedPolicyNominees((prevItems) => prevItems.filter((item) => item.id != row.id));
          }}
        >
          Delete
        </Button>
      </Stack>
    );
  };
  const handleNomineeEdit = (nomineeId) => {
    let existingNominee = usedPolicyNominees.filter((x) => x.id == nomineeId);
    const updatedNominees = usedPolicyNominees.filter((nominee) => nominee.id !== nomineeId);
    setUsedPolicyNominees(updatedNominees);
    if (existingNominee && existingNominee[0]) {
      nomineesReset({
        address: existingNominee[0].address,
        allocationPercentage: existingNominee[0].allocationPercentage,
        firstName: existingNominee[0].firstName,
        lastName: existingNominee[0].lastName,
        phone: existingNominee[0].phone,
        id: existingNominee[0].id,
      });
    }
  };

  const CategoryOption = [
    { value: 1, label: "Other" },
    { value: 2, label: "Company" },
  ];
  return (
    // <MainCard title="Insurance Form">
    <>
      <Box sx={{ padding: '30px 0', width: '100%' }}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={() => setIsShowForm(false)} startIcon={<ArrowBackIcon />}>
              Back
            </Button>
          </Box>
        </Grid>
        {/* <Typography variant="h3">Loan Form</Typography> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset style={styles.fieldset}>
            <legend style={styles.legend}>Policy Information</legend>

            <Grid container spacing={2}>
              <Grid item sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="policyNumber"
                    control={control}
                    render={({ field }) => <TextField {...field} label="Policy Number" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.policyNumber}</div>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="provider"
                    control={control}
                    render={({ field }) => <TextField {...field} type="text" label="Provider" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.provider}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Category</InputLabel>
                  <Controller
                    name="category"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        labelId="type-label"
                        label="Category"
                        {...field}
                        onChange={(event) => {
                          const value = event;
                          field.onChange(value);
                        }}
                        value={field.value || ""}
                      >
                        {CategoryOption.map((x, i) => (
                          <MenuItem value={x.value} key={i}>
                            {x.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.category}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="expirationDate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="expiration-date"
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        {...field}
                        type="date"
                        label="Expiration Date"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.expirationDate}</div>

                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="policyName"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="policy-name"
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        {...field}
                        type="text"
                        label="Policy Name"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.policyName}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="coverAmount"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="cover-amount"
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        {...field}
                        type="number"
                        label="Cover Amount"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.coverAmount}</div>

                </FormControl>
              </Grid>
            </Grid>
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Document Information</legend>
            <DocumentUploader
              onUpload={handleUpload}
              documentList={documentList}
              onRemove={handleRemove}
              onRemoveExistDoc={handleRemoveExistDoc}
              existDocumentList={existingDoc}
            />
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Policy Nominees Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  {/* <InputLabel id="type-label">First Name</InputLabel> */}
                  <Controller
                    name="firstName"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="First Name" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.firstName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="lastName"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="Last Name" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.lastName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="phone"
                    control={nomineesControl}
                    render={({ field }) =>
                      <PhoneInput
                        {...field}
                        country={'in'}
                        onChange={(value) => field.onChange(value)}
                        inputStyle={{ width: '100%' }}
                      />
                    }
                  />
                  <div style={{ color: 'red' }}>{formErrors.phone}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="address" control={nomineesControl} render={({ field }) =>
                    <ResizableTextField
                      {...field}
                      label="Address"
                      multiline
                      rows={4}
                    />
                  } />
                  <div style={{ color: 'red' }}>{formErrors.address}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="allocationPercentage"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="AllocationPercentage" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.allocationPercentage}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "10px" }}
                    onClick={saveNominees}
                  >
                    Save Nominee
                  </Button>
                </Box>
              </Grid>
              {usedPolicyNominees && usedPolicyNominees.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
                  <NomineeDetails nominees={usedPolicyNominees} columns={columns} />
                </Grid>
              )}
            </Grid>
          </fieldset>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
            <Button type="submit" variant="contained" color="primary" className="mt-4" style={{ marginRight: '15px' }}>
              Submit
            </Button>
            <Button type="button" variant="contained" color="error" onClick={() => setIsShowForm(false)}>
              Cancel
            </Button>
          </Grid>
        </form>
      </Box>
      <LoadingBackdrop open={isLoading} />
    </>
    // </MainCard>
  );
}

export default AddEditPolicyForm;

const styles = {
  fieldset: {
    border: '1px solid #364152',
    borderRadius: '8px',
    padding: '20px'
  },
  legend: {
    color: '#364152',
    padding: '0 10px',
    fontSize: '18px'
  }
};
const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
};
